export default function absCeil(number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/abs-ceil.js
// module id = 1376
// module chunks = 3